<template>
  <span
    v-if="priority"
    v-tooltip="{
      content: tooltipText,
      delay: { show: 1500, hide: 0 },
      hideOnClick: true,
    }"
    class="shrink-0 rounded-sm inline-flex"
  >
    <img :src="priorityBadgeIcon" alt="Priority Icon" class="w-4 h-4" />
  </span>
</template>

<script>
import { CONVERSATION_PRIORITY } from '../../../../shared/constants/messages';

import highIcon from 'dashboard/assets/images/priority_icons/high.svg';
import lowIcon from 'dashboard/assets/images/priority_icons/low.svg';
import mediumIcon from 'dashboard/assets/images/priority_icons/medium.svg';
import urgentIcon from 'dashboard/assets/images/priority_icons/urgent.svg';

const PRIORITY_BADGE_ICONS = {
  [CONVERSATION_PRIORITY.HIGH]: highIcon,
  [CONVERSATION_PRIORITY.LOW]: lowIcon,
  [CONVERSATION_PRIORITY.MEDIUM]: mediumIcon,
  [CONVERSATION_PRIORITY.URGENT]: urgentIcon,
};

export default {
  name: 'PriorityMark',
  props: {
    priority: {
      type: String,
      default: '',
      validate: value =>
        [...Object.values(CONVERSATION_PRIORITY), ''].includes(value),
    },
  },
  data() {
    return {
      CONVERSATION_PRIORITY,
    };
  },
  computed: {
    tooltipText() {
      return this.$t(
        `CONVERSATION.PRIORITY.OPTIONS.${this.priority.toUpperCase()}`
      );
    },
    priorityBadgeIcon() {
      return PRIORITY_BADGE_ICONS[this.priority];
    },
    isUrgent() {
      return this.priority === CONVERSATION_PRIORITY.URGENT;
    },
  },
};
</script>
